import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-lead-creation',
    templateUrl: './lead-creation.component.html',
    styleUrls: ['./lead-creation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeadCreationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
